export var IFrameState;
(function (IFrameState) {
    IFrameState["Loading"] = "loading";
    IFrameState["Loaded"] = "loaded";
    IFrameState["Recording"] = "recording";
})(IFrameState || (IFrameState = {}));
